var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"f-col"},[_c('div',{staticClass:"textClass",style:(`width: ${_vm.labelWidth}rem; min-width: ${_vm.labelWidth}rem`)},[_vm._v(" "+_vm._s(_vm.label)+" ")]),(_vm.value)?_c('div',{class:['textClass', _vm.classes]},[_vm._v(" "+_vm._s(_vm.value)+" ")]):_vm._e(),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }